__turbopack_context__.v({
  "operator": "personal-account-banner-module-scss-module__2LGM8a__operator",
  "operator__icon": "personal-account-banner-module-scss-module__2LGM8a__operator__icon",
  "operator__textBlock": "personal-account-banner-module-scss-module__2LGM8a__operator__textBlock",
  "slideUp": "personal-account-banner-module-scss-module__2LGM8a__slideUp",
});
